<div class="container">
  <div class="text">
    {{ value }}
  </div>

  @if (value) {
    <button
      type="button"
      class="copy-btn"
      (click)="copyToClipboard()"
      title="Copy to clipboard"
    >
      @if (!copied()) {
        <i class="fa fa-clone" title="Copy to clipboard"></i>
      } @else {
        <i class="fa fa-check-circle-o" title="Copied"></i>
      }
    </button>
  }
</div>
